import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

interface TopDescriptionsResponse {
  descriptions: string[];
}

export const topDescriptionKeys = {
  all: ['topDescriptions'] as const,
  list: () => [...topDescriptionKeys.all, 'list'] as const,
};

export function useTopDescriptions() {
  return useQuery({
    queryKey: topDescriptionKeys.list(),
    queryFn: async () => {
      const response = await apiClient.get<TopDescriptionsResponse>('/expenses/top-descriptions');
      return response.descriptions;
    },
    staleTime: 5 * 60 * 1000, // 5 min — description rankings shift slowly
  });
}
